type BridgeSessionParams = {
  accessToken: string
  refreshToken: string
  keepLoggedIn: boolean
  next: string
}

function readFromHash(hash: string) {
  const normalized = hash.startsWith('#') ? hash.slice(1) : hash
  if (!normalized) return null

  const params = new URLSearchParams(normalized)
  const accessToken = params.get('accessToken')
  const refreshToken = params.get('refreshToken')

  if (!accessToken || !refreshToken) return null

  return {
    accessToken,
    refreshToken,
    keepLoggedIn: params.get('keepLoggedIn') === 'true',
    next: params.get('next') || 'dashboard',
  }
}

export function readBridgeSessionParams(): BridgeSessionParams | null {
  return readFromHash(window.location.hash)
}

export function clearBridgeSessionParamsFromUrl() {
  const url = new URL(window.location.href)
  url.hash = ''
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}`)
}
